import { useQuery } from '@tanstack/react-query';
import { getLoanDefinitionDataByMipId } from '@dealstack/frontend/shared/dataExchange/services/mip.service';
import API_PATHS from '@dealstack/shared/lib/generated/apiPaths.ts';

export const useGetLoans = () => {
	return useQuery({
		queryKey: [API_PATHS.MIP_LOAN_DEFINITION_GET],
		queryFn: () => getLoanDefinitionDataByMipId(),
	});
};
